import { render, staticRenderFns } from "./BillIndexTable.vue?vue&type=template&id=69236524"
import script from "./BillIndexTable.vue?vue&type=script&lang=js"
export * from "./BillIndexTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports